import { createEffect, createSignal, on, onCleanup, type Accessor } from "solid-js";

/** Accessor that follows `source` after it has been stable for `ms`. */
export function createDebounced<T>(source: Accessor<T>, ms: number): Accessor<T> {
  const [value, setValue] = createSignal(source());
  let timer: ReturnType<typeof setTimeout> | undefined;
  createEffect(
    on(
      source,
      (v) => {
        clearTimeout(timer);
        timer = setTimeout(() => setValue(() => v), ms);
      },
      { defer: true },
    ),
  );
  onCleanup(() => clearTimeout(timer));
  return value;
}
